import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Sparkles, TrendingUp, GraduationCap, Briefcase, Award, Target, Zap, Coins } from "lucide-react";

const ICONS = { "trending-up": TrendingUp, "graduation-cap": GraduationCap, briefcase: Briefcase, award: Award, target: Target, zap: Zap, coins: Coins, sparkles: Sparkles };

export default function Insights() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { api.get("/insights").then(r => setItems(r.data)); }, []);

  const gen = async () => {
    setLoading(true);
    try { const { data } = await api.post("/insights/generate"); setItems(data); toast.success("Fresh insights ready"); }
    catch (e) { toast.error("Complete profile first"); } finally { setLoading(false); }
  };

  return (
    <div className="p-10 max-w-5xl" data-testid="insights-page">
      <div className="flex justify-between items-start mb-10">
        <div>
          <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-2">Module 06</div>
          <h1 className="font-display font-bold text-5xl tracking-tight">Daily Insights</h1>
        </div>
        <button data-testid="insights-generate" onClick={gen} disabled={loading} className="inline-flex items-center justify-center rounded-md bg-primary text-primary-foreground hover:bg-primary/90 font-semibold transition-colors px-6 py-2.5 text-sm">{loading?"Generating...":"Generate fresh insights"}</button>
      </div>
      {items.length === 0 ? (
        <div className="card-flat p-12 text-center text-muted-foreground">No insights yet. Click Generate to get personalized recommendations.</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {items.map((ins, i) => {
            const Icon = ICONS[ins.icon] || Sparkles;
            return (
              <div key={ins.id || i} className="card-flat p-5" data-testid={`insight-${i}`}>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 bg-primary flex items-center justify-center shrink-0"><Icon size={16} className="text-foreground"/></div>
                  <div className="min-w-0">
                    <div className="font-display font-bold text-base mb-1">{ins.title}</div>
                    <div className="text-sm text-muted-foreground leading-relaxed">{ins.description}</div>
                    <div className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground/60 mt-3">{ins.category}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
